import { jsx as _jsx } from "react/jsx-runtime";
import { Provider as ReduxProvider } from "react-redux";
import { ComponentsContext, } from "../../helpers/components";
import { AppChannelProvider } from "./app-channel";
function AppContext({ store, components = {}, appChannelListeners = [], children, }) {
    return (_jsx(ReduxProvider, { store: store, children: _jsx(AppChannelProvider, { listeners: appChannelListeners, children: _jsx(ComponentsContext.Provider, { value: components, children: children }) }) }));
}
export default AppContext;
